import * as Arabic from "../characters/arabic";
import * as Chinese from "../characters/chinese";
import * as Hiragana from "../characters/hiragana";
import * as katakana from "../characters/katakana";

export const chooseLanguage = (language: string) => {
  if (language === "arabic") {
    return Arabic;
  } else if (language === "chinese") {
    return Chinese;
  } else if (language === "hiragana") {
    return Hiragana;
  } else {
    return katakana;
  }
};
